import apiSlice from "./ApiSlice";

const ModuleApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // get all delivery dates
    getAllModuleData: builder.query({
      providesTags: ["module"],
      query: (body: PaginationPayloadType) => {
        return {
          url: "/module",
          method: "POST",
          body,
        };
      },
    }),

    // delete delivery date
    deleteModuleById: builder.mutation({
      invalidatesTags: ["module"],
      query: (id: any) => ({
        url: `/module/${id}`,
        method: "DELETE",
      }),
    }),
    // add delivery date
    addModule: builder.mutation({
      invalidatesTags: ["module"],
      query: (body) => ({
        url: `/module/add`,
        method: "POST",
        body,
      }),
    }),
    //get delivery date by Id
    getModuleById: builder.query({
      providesTags: ["module"],
      query: (id: string) => {
        return {
          url: `/module/${id}`,
          method: "GET",
        };
      },
    }),


    //get Payment Modes
    getAllModule: builder.query({
      providesTags: ["module"],
      query: () => {
        return {
          url: `/module`,
          method: "GET",
        };
      },
    }),

    // update delivery date
    updateModuleById: builder.mutation({
      invalidatesTags: ["module"],
      query: ({ body, id }) => ({
        url: `/module/${id}`,
        method: "PUT",
        body,
      }),
    }),

    // change status of delivery date
    changeStatusModuleById: builder.mutation({
      invalidatesTags: ["module"],
      query: ({ body, id }) => ({
        url: `/module/status-change/${id}`,
        method: "PUT",
        body,
      }),
    }),
  }),
});

export const {
  useGetAllModuleDataQuery,
  useDeleteModuleByIdMutation,
  useAddModuleMutation,
  useGetModuleByIdQuery,
  useUpdateModuleByIdMutation,
  useGetAllModuleQuery,
  useChangeStatusModuleByIdMutation,
} = ModuleApi;
